var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "formRef",
      attrs: {
        model: _vm.form,
        "label-width": "100px",
        "label-position": _vm.getIsMobile ? "top" : "right",
      },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "备注" } },
        [
          _vm._l(_vm.form.child_content, function (remark, index) {
            return _c(
              "div",
              { key: index, staticClass: "remark-item" },
              [
                _c("el-input", {
                  attrs: { type: "textarea", placeholder: "请输入备注内容" },
                  model: {
                    value: remark.content,
                    callback: function ($$v) {
                      _vm.$set(remark, "content", $$v)
                    },
                    expression: "remark.content",
                  },
                }),
                _c(
                  "el-button",
                  {
                    staticClass: "remark-delete",
                    attrs: { type: "danger" },
                    on: {
                      click: function ($event) {
                        return _vm.removeRemark(index)
                      },
                    },
                  },
                  [_vm._v("删除")]
                ),
              ],
              1
            )
          }),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.addRemark } },
            [_vm._v("新增备注")]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }